// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/group_class_attendance.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { GroupClassAttendanceStatus } from "../../enum/v1/group_class_attendance_status_pb.js";

/**
 * @generated from message fingertip.common.type.v1.GroupClassAttendance
 */
export const GroupClassAttendance = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.GroupClassAttendance",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "message", T: Timestamp },
    { no: 3, name: "updated_at", kind: "message", T: Timestamp },
    { no: 4, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(GroupClassAttendanceStatus) },
    { no: 7, name: "cancellation_charged_at", kind: "message", T: Timestamp },
    { no: 8, name: "no_show_charged_at", kind: "message", T: Timestamp },
    { no: 9, name: "booking_charged_at", kind: "message", T: Timestamp },
    { no: 10, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "cancelled_at", kind: "message", T: Timestamp },
    { no: 13, name: "rejected_at", kind: "message", T: Timestamp },
    { no: 14, name: "completed_at", kind: "message", T: Timestamp },
    { no: 15, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "store_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "confirmed_at", kind: "message", T: Timestamp },
    { no: 18, name: "rejection_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

